import React from 'react'
import PropTypes from 'prop-types'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import OverviewHero from './OverviewHero'
import SectionNavCards from './SectionNavCards'

export default function Overview({
  assessment = {},
  summary = {},
  recommendations = [],
  findings = [],
  domainScores = [],
  data = {},
  dataAvailability = [],
}) {
  return (
    <>
      <SectionHeading titleId="AI_RISK_REPORT.OVERVIEW.TITLE" />
      <OverviewHero assessment={assessment} summary={summary} quickWins={recommendations} findings={findings} />
      <SectionNavCards summary={summary} domainScores={domainScores} data={data} dataAvailability={dataAvailability} />
    </>
  )
}

Overview.propTypes = {
  assessment: PropTypes.shape({}),
  summary: PropTypes.shape({}),
  recommendations: PropTypes.arrayOf(PropTypes.shape({})),
  findings: PropTypes.arrayOf(PropTypes.shape({})),
  domainScores: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape({}),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
